if(!customElements.get('quiz')){
    class QuizElement extends HTMLElement {
      constructor() {
        super();
        this.table = this.querySelector(".quiz-table");
        this.tableOuter = this.table.closest(".quiz-table-outer");
        this.firstRow = this.table.querySelector('.quiz-row.quiz-first-row');
        this.firstMid = this.firstRow.querySelector('.quiz-mid-col');
        this.productName = this.table.dataset.productType.toLowerCase();
        this.functionData = window.quizFunctionData;
        this.globalAvailability = window.yearNameCombos;
        this.step2 = this.querySelector(".quiz-step-2");
        this.step2Wrapper = this.step2.closest(".quiz-step-wrapper");
        this.step2Heading = this.step2.querySelector(".quiz-step-heading");
        this.originalHeading = this.step2Heading.textContent;

        const header = document.querySelector('.shopify-section-header');
        this.headerHeight = header.getBoundingClientRect().height;
        if (!this.productName || !this.functionData || !this.globalAvailability)
          return;

        this.rows = this.table.querySelectorAll(
          ".quiz-row:not(.quiz-first-row)"
        );
      }
      connectedCallback(){
        this.init();
        this.choices.forEach((choice) => {
          choice.addEventListener("click", () => this.styleChoices(choice));
        });
        this.nameChoices.forEach((choice) => {
          choice.addEventListener("click", () => this.handleNameChoice(choice));
        });
      }
      init() {
        this.initRows();
        this.initNameChoices();
        this.initYears();
        this.initTable();
        this.handleUrlParams();
      }
      initNameChoices(){
        this.choices = this.querySelectorAll(".quiz-choice");
        this.nameChoices = [...this.choices]
          .filter(n => n.classList.contains("quiz-name-choice"))
          .sort((a, b) => Number(a.dataset.orderNumber) - Number(b.dataset.orderNumber));
        
        // Update DOM order
        const parent = this.nameChoices[0].parentElement;
        this.nameChoices.forEach(choice => {
          parent.appendChild(choice);
        });
      }
      initTable(){
        const resizeObserver = new ResizeObserver(entries => {
          for (const entry of entries) {
            this.tableOuter.scrollWidth > this.tableOuter.clientWidth 
              ? this.tableOuter.classList.add('scrollable')
              : this.tableOuter.classList.remove('scrollable');
          }
        });

        resizeObserver.observe(this.tableOuter);
      }
      initRows(){
        this.rows.forEach((row) => {
          row.functionData = this.functionData[row.dataset.functionId];
        });

        this.rows = [...this.rows].sort((a, b) => {
            const a_cn = a.functionData.categoryOrderNumber;
            const b_cn = b.functionData.categoryOrderNumber;
            if(a_cn == b_cn){
                return a.functionData.orderNumber - b.functionData.orderNumber;
            }
            return a_cn - b_cn;
        })

        let currentCategory;
        // Remove all rows from DOM temporarily
        this.rows.forEach(row => row.remove());
        
        // Add back rows in sorted order
        this.rows.forEach(row => {
          const category = row.functionData.categoryName;
          if (category !== currentCategory) {
            this.table.appendChild(this.createCategory(category));
            currentCategory = category;
          }
          this.table.appendChild(row);

        });
      }
      initYears() {
        const groupedYears = this.groupYearCombosByYear(this.globalAvailability);
        const yearContainer = this.step2.querySelector('.quiz-year-container');
        this.years = [];
        Object.entries(groupedYears).forEach(([year, names]) => {
            const newYearElement =  this.createYear(year, names);
            this.nameChoices.forEach(name => {
                if(names.find((n) => {
                    const lowerCase = name.textContent.toLowerCase();
                    const filtered = this.removeWhiteSpace(lowerCase);
                    return this.removeWhiteSpace(n) == filtered
                })) 
                name.activeYears = !name.activeYears ? [year] : [...name.activeYears, year];
            })
            this.years = [...this.years, newYearElement];
        })

        this.years = this.years.reverse();
        this.years.forEach(y => yearContainer.appendChild(y));
      }
      createYear(year, names) {
        const div = document.createElement("div");
        div.classList.add("quiz-year", "quiz-choice", "lh-l", "ls-s", "fs-l",  "fw-bold", "flex-center", "text-center");
        div.names = names; // Set names as a direct attribute
        div.year = year;
        // Capitalize Year
        div.textContent = year.replace(/\b\w/g, char => char.toUpperCase());
        div.addEventListener('click', (e) => {
            e.stopPropagation();
            this.styleChoices(div);
        })
        div.addEventListener('click', () => {
            this.handleYearChoice(div);
        })
        return div;
      }
      createCategory(category){
        const categoryRow = document.createElement('div');
        const categoryFirstCol = document.createElement('div');
        const categoryMidCol = document.createElement('div');
        const categoryLastCol = document.createElement('div');
        categoryRow.classList.add('quiz-row', 'quiz-category-row');
        categoryFirstCol.classList.add('quiz-col', 'quiz-first-col', 'fs-m', 'fs-s--mobile', 'lh-l', 'ls-xs', 'fw-bold');
        categoryMidCol.classList.add('quiz-col', 'quiz-mid-col');
        categoryLastCol.classList.add('quiz-col', 'quiz-last-col');
        categoryFirstCol.textContent = category;
        categoryRow.append(categoryFirstCol, categoryMidCol, categoryLastCol);
        return categoryRow;
      }
      groupYearCombosByYear(data) {
        const groupedByYear = data.reduce((acc, item) => {
          const year = item.year.trim();
          if (!acc[year]) {
            acc[year] = []; // Initialize the array for the year if it doesn't exist
          }
          if (!acc[year].includes(item.name)) {
            acc[year].push(item.name); // Add the model name if it's not already in the array
          }
          return acc;
        }, {});
        return groupedByYear;
      }
      handleNameChoice(choice,noScroll=false,skipUrlUpdate=false) {
        const filtered = this.removeWhiteSpace(choice.textContent.toLowerCase())
        if(this.chosenName === filtered) return;
        this.chosenNameContent = choice.textContent.trim();
        this.chosenName = filtered;
        this.step2Heading.textContent = `${this.originalHeading} ${choice.textContent}`;
        this.years.forEach(y => y.classList.remove('not-hidden'));
        this.resetYears();
        
        if (!skipUrlUpdate) {
          this.setUrlHash({ model: this.chosenNameContent });
        }
        
        new Promise((resolve) => {
          choice?.activeYears?.forEach(ay => {
              this.years.forEach(y => {
                  if(ay == y.year) y.classList.add('not-hidden');
              })
            resolve();
          })
        }).then(() => {
          this.revealElement(this.step2Wrapper, this.step2.offsetHeight,noScroll);
        });
      }
      resetYears(){
        this.years.forEach(y => {
            y.classList.remove('active');
        })
      }
      handleYearChoice(choice,skipUrlUpdate=false){
        this.chosenYear = choice.year.toLowerCase();
        const year = this.firstMid.querySelector('.year');
        const model = this.firstMid.querySelector('.model');
        model.textContent = this.chosenNameContent;
        year.textContent = choice.year;
        
        if (!skipUrlUpdate) {
          this.setUrlHash({ model: this.chosenNameContent, year: choice.year });
        }
        
        this.rows.forEach(row => {
            const availability = row.functionData[`${this.productName}Availability`];
            availability.some(entry => 
            {
                return this.removeWhiteSpace(entry.name) == this.chosenName 
                && entry.year == this.chosenYear
            }) ? row.classList.add('active') : row.classList.remove('active');
        })
        const tableAbsoluteBuffer = 30;
        const maxHeight = this.table.offsetHeight + tableAbsoluteBuffer; 
        this.revealElement(this.tableOuter, maxHeight);
      }
      revealElement(el, maxHeight,noScroll=false){
        el.style.setProperty('max-height', maxHeight + 'px');
        el.style.setProperty('opacity', 1);
        el.classList.add('active');
        if(!noScroll) setTimeout(() => {this.scrollToElement(el)}, 500)
      }
      styleChoices(choice) {
        const localChoices = choice
          .closest(".quiz-choices")
          .querySelectorAll(".quiz-choice");
        localChoices.forEach((lc) => {
          lc.classList.remove("active");
        });
        choice.classList.add("active");
      }

      handleUrlParams(){
        if(!window.location.hash) return;
        const params = this.parseUrlHash();
        const modelParam = params?.model;
        const yearParam = params?.year;

        if (!modelParam) return;

        const matchingNameChoice = this.nameChoices.find(choice => {
          const choiceText = this.removeWhiteSpace(choice.textContent.toLowerCase());
          const paramText = this.removeWhiteSpace(modelParam.toLowerCase());
          return choiceText === paramText;
        });

        if (!matchingNameChoice) return;

        const namePromise = new Promise((resolve) => {
          this.styleChoices(matchingNameChoice);
          this.handleNameChoice(matchingNameChoice,!!yearParam,true);
          resolve();
        });
         namePromise.then(() => {
           if (!yearParam) return;
           const matchingYearChoice = this.years.find(yearChoice => {
             const yearText = this.removeWhiteSpace(yearChoice.year.toLowerCase());
             const paramText = this.removeWhiteSpace(yearParam.toLowerCase());
             return yearText === paramText;
           });
           if (!matchingYearChoice || !matchingYearChoice.classList.contains('not-hidden')) return;
           this.styleChoices(matchingYearChoice);
           this.handleYearChoice(matchingYearChoice,true);
         });
      }
      parseUrlHash(){
        const params = {};
        const queryString = window.location.hash.substring(1);
        if(!queryString) return params;
        const keyValuePairs = queryString.split('&&');
        keyValuePairs.forEach(pair => {
          const [key, value] = pair.split('=');
          params[key.trim()] = decodeURIComponent(value.trim());
        });
        return params;
      }
      setUrlHash(params){
        const hashParts = [];
        
        for (const key in params) {
          if (params[key]) {
            hashParts.push(`${key}=${(this.removeWhiteSpace(params[key]).toLowerCase())}`);
          }
        }
        
        const newHash = hashParts.join('&&');
        window.history.replaceState(null, '', `#${newHash}`);
      }

      removeWhiteSpace(text){
        return text.replace(/\s+/g, '');
      }
      scrollToElement(el){
        const buffer = 30
        window.scrollTo({
            "top": el.offsetTop - buffer - this.headerHeight,
            "behavior": "smooth"
        })
      }
    }
    customElements.define("quiz-element", QuizElement);
}